module.exports = __webpack_public_path__ + "static/media/apple_logo_white.862f4578.svg";